import type { ServerColDef } from '@cmg/data-grid';
import { createValueFormatter } from '@cmg/data-grid';

import type { FirmInvestorContactsGridItemFragment } from '../graphql/__generated__';

export const valueFormatter = createValueFormatter<
  FirmInvestorContactsGridItemFragment,
  FirmInvestorContactsGridItemFragment['name']
>();

export const investorEmployeeNameColDef: ServerColDef<FirmInvestorContactsGridItemFragment> = {
  field: 'name',
  headerName: 'Employee Name',
  valueFormatter,
};
